__turbopack_context__.v({
  "button": "QnBNpG_button",
  "content": "QnBNpG_content",
  "danger": "QnBNpG_danger",
  "fullWidth": "QnBNpG_fullWidth",
  "ghost": "QnBNpG_ghost",
  "icon": "QnBNpG_icon",
  "iconOnly": "QnBNpG_iconOnly",
  "lg": "QnBNpG_lg",
  "loading": "QnBNpG_loading",
  "md": "QnBNpG_md",
  "primary": "QnBNpG_primary",
  "secondary": "QnBNpG_secondary",
  "sm": "QnBNpG_sm",
  "spin": "QnBNpG_spin",
  "spinner": "QnBNpG_spinner",
  "steam": "QnBNpG_steam",
  "success": "QnBNpG_success",
});
